module.exports = __webpack_public_path__ + "static/working-office-75808d2d5f879065155e2fb1c09852ca.svg";